import InfoWithPopup from "./InfoIconWithPopup";

export default InfoWithPopup